import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class rss
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.rss = {};

/**
 * GET Endpoint `/rss/feed/widget=`
 * @param {number} widget_id
 * @param {number} posts
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.rss
 */
ReachAPI.rss.getFeedForWidget = function (widget_id, posts, security) {
    var cache_id = '/rss/feed/widget=' + widget_id;
    var url = ReachAPI.server + '/rss';
    var params = {
        widget_id: widget_id,
        posts: posts,
        format: 'json',
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Feed from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Feed from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Feed',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/rss/feed/type=`
 * @param {string} type
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.rss
 */
ReachAPI.rss.getFeedForAnnouncement = function (type) {
    var cache_id = '/rss/feed/type=' + type;
    var url = ReachAPI.server + '/rss';
    var params = {
        type: type,
        posts: 1,
        format: 'json',
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Feed from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Feed from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Feed',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
